module.exports = __webpack_public_path__ + "static/img/third2_1_3_active.8649d71e.jpg";